export enum NovaErrorCode {
  ScheduleConflict = 'schedule-conflict',
  AtomicScheduleConflict = 'atomic-schedule-conflict',
  UnverifiedEmail = 'unverified-email',
  UserNotFound = 'user-not-found',
  UserAccountBlocked = 'user-account-blocked',
  PasswordLoginForbidden = 'password-login-forbidden',
  InternalLoginForbidden = 'internal-login-forbidden',
  ReferenceNumberValidationFailure = 'reference-number-validation-failure', // Internal validations
  ExternalValidationFailure = 'external-validation-failure',
  ExternalValidationServerError = 'external-validation-server-error',
  ExternalValidationFailureOverridden = 'external-validation-failure-overridden',
  PickupAssetContainerUnavailable = 'pickup-asset-container-unavailable'
}
